function onClickSearchBtn() {
  $(".aplenglowee-search-panel").addClass("active");

  $(document).on("click", onClickOutsideSearchBtn);

  function onClickOutsideSearchBtn(event) {
    if (!event.target.closest("header")) {
      $(".aplenglowee-search-panel").removeClass("active");
      $(document).off("click", onClickOutsideSearchBtn);
    }
  }
}

function openMenu() {
  $(".aplenglowee-menu").addClass("active");
  $(".aplenglowee-menu-btn").addClass("active");
  $("body").addClass("mask-active");
}

function closeMenu() {
  $(".aplenglowee-menu").removeClass("active");
  $(".aplenglowee-menu-btn").removeClass("active");
  $(".aplenglowee-menu-item-group-with-child").removeClass("active");
  $("body").removeClass("mask-active");
}

function formatPrice(price) {
  const USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
  });

  return USDollar.format(price / 100);
}

function updateCartDrawer() {
  const emptyElement = `
    <div class="aplenglowee-cart-empty">
      <div class="aplenglowee-cart-empty-text">Your cart is empty</div>
      <a href="/collections/all">
        Continue shopping
      </a>
    </div>`;

  function genCartContainer({ children, totalPrice }) {
    return `
    <div class="aplenglowee-cart-drawer-content">
      <div class="aplenglowee-cart-items-container">
        ${children}  
      </div>
      <div class="aplenglowee-cart-action-group">
        <div class="aplenglowee-total">Total ${formatPrice(totalPrice)}</div>
        <div class="aplenglowee-total-note">Shipping and taxes calculated at checkout.</div>
        <a href="/cart" class="aplenglowee-checkout">CHECKOUT</a>
      </div>
    </div>
    `;
  }

  function genCartItem(item) {
    return `
      <div 
         class="aplenglowee-cart-item" 
         data-id="${item.variant_id}" 
         data-line-price="${item.final_price}"
      >
        <a class="aplenglowee-item-image" href="${item.url}">
          <div
            class="aplenglowee-item-image-src"
            style="background-image: url('${item.image}')"
          >
            <div class="aplenglowee-fake-content">empty</div>
          </div>
        </a>

        <div class="aplenglowee-item-content">
          <div class="aplenglowee-item-title">${item.product_title}</div>

          <div class="aplenglowee-item-info">
            ${
              item.variant_title
                ? '<div class="aplenglowee-item-size">' +
                  item.variant_title +
                  "</div>"
                : ""
            }
            <div
              class="aplenglowee-item-price-group"
            >
              <div class="aplenglowee-item-price">
                ${formatPrice(item.final_line_price)}
              </div>
            </div>
          </div>

          <div class="aplenglowee-cart-item-action-group">
            <div class="aplenglowee-amount-selector">
              <div class="aplenglowee-mimus" onclick="minusCartDrawerItemAmount(this)">
                <svg width="10" height="1" viewBox="0 0 10 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line x1="0.25" y1="0.75" x2="9.75" y2="0.75" stroke="black" stroke-width="0.5" stroke-linecap="round"></line>
                </svg>
              </div>
              <input
                class="aplenglowee-cart-drawer-item-amount"
                name="quantity"
                type="number"
                min="1"
                value="${item.quantity}"
              >
              <div class="aplenglowee-add" onclick="addCartDrawerItemAmount(this)">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line x1="0.25" y1="4.75" x2="9.75" y2="4.75" stroke="black" stroke-width="0.5" stroke-linecap="round"></line>
                  <line x1="5.25" y1="0.25" x2="5.25" y2="9.75" stroke="black" stroke-width="0.5" stroke-linecap="round"></line>
                </svg>
              </div>
              <div class="aplenglowee-border-thin"><div></div></div>
            </div>
            <div class="aplenglowee-cart-item-delete" onclick="deleteCartDrawerItem(this)">
              <img src="//alpenglowee.com/cdn/shop/t/1/assets/icon-delete.png?v=2580869546109122381690791578" loading="lazy" alt="delete">
            </div>
          </div>
        </div>
      </div>`;
  }

  function updateCartDrawerData(cart) {
    const $drawer = $(".aplenglowee-cart-drawer");
    const $cartCount = $(".aplenglowee-cart-count");

    const isEmpty = cart.items.length === 0;

    if (isEmpty) {
      $drawer.html(emptyElement);
      $cartCount.text("");
    } else {
      $cartCount.text(`(${cart.item_count})`);

      const itemContents = cart.items
        .map((item) => {
          return genCartItem(item);
        })
        .join("");
      const container = genCartContainer({
        children: itemContents,
        totalPrice: cart.total_price,
      });
      $drawer.html(container);
    }
  }

  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (data) {
      updateCartDrawerData(data);
    },
  });
}

function deleteCartDrawerItem(target) {
  const $item = $(target).closest(".aplenglowee-cart-item");
  const productId = $item.attr("data-id");

  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    dataType: "json",
    data: { updates: { [productId]: 0 } },
    success: function () {
      updateCartDrawer();
    },
  });
}

function addCartDrawerItemAmount(target) {
  const $cartItem = $(target).closest(".aplenglowee-cart-item");
  const $amount = $cartItem.find(".aplenglowee-cart-drawer-item-amount");
  const $price = $cartItem.find(".aplenglowee-item-price");

  const amount = parseInt($amount.val(), 10);
  const cartItemId = $cartItem.attr("data-id");
  const cartItemLinePrice = $cartItem.attr("data-line-price");

  const newAmount = amount + 1;

  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    dataType: "json",
    data: { updates: { [cartItemId]: newAmount } },
    success: function () {
      updateCartDrawer();
    },
  });
}

function minusCartDrawerItemAmount(target) {
  const $cartItem = $(target).closest(".aplenglowee-cart-item");
  const $amount = $cartItem.find(".aplenglowee-cart-drawer-item-amount");
  const $price = $cartItem.find(".aplenglowee-item-price");

  const amount = parseInt($amount.val(), 10);
  const cartItemId = $cartItem.attr("data-id");
  const cartItemLinePrice = $cartItem.attr("data-line-price");

  if (amount > 1) {
    const newAmount = amount - 1;

    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      dataType: "json",
      data: { updates: { [cartItemId]: newAmount } },
      success: function () {
        updateCartDrawer();
      },
    });
  }
}

function openCartDrawer() {
  $("body").addClass("mask-active");
  $(".aplenglowee-cart-drawer").addClass("active");
  // updateCartDrawer();
}

function closeCartDrawer(target) {
  $("body").removeClass("mask-active");
  $(".aplenglowee-cart-drawer").removeClass("active");
}

function toggleCartDrawer() {
  const isOpen = $(".aplenglowee-cart-drawer").hasClass("active");
  if (isOpen) {
    closeCartDrawer();
  } else {
    openCartDrawer();
  }
}

function closeDrawers() {
  closeMenu();
  closeCartDrawer();
}

function toggleMenuItem(target) {
  $(target)
    .closest(".aplenglowee-menu-item-group-with-child")
    .toggleClass("active");
}

function handleMenuScrollState() {
  const path = location.href.replace(shopUrl, "").split("?")[0];

  function addScrollingClass() {
    $(".aplenglowee-header").addClass("scrolling");
  }
  function removeScrollingClass() {
    $(".aplenglowee-header").removeClass("scrolling");
  }

  if (path === "/") {
    let scrollingTimeout = null;

    function handleMenuOnScroll() {
      if (scrollingTimeout) {
        window.clearTimeout(scrollingTimeout);
      }

      addScrollingClass();
      scrollingTimeout = window.setTimeout(removeScrollingClass, 500);

      if (window.scrollY > window.innerHeight) {
        $(".aplenglowee-header").removeClass("aplenglowee-header-white");
      } else {
        $(".aplenglowee-header").addClass("aplenglowee-header-white");
      }
    }
    $(document).on("scroll", handleMenuOnScroll);
  }
}

function handleHeaderHeight() {
  function toggleClass() {
    if (window.scrollY > 10) {
      $(".aplenglowee-header").addClass("small");
    } else {
      $(".aplenglowee-header").removeClass("small");
    }
  }

  $(document).on("scroll", toggleClass);
}

function handleClickOutsideCartDrawer() {
  $(document).on("click", function (event) {
    if (window.innweWidth < 600) {
      const $cartBtnSelector = $(event.target).closest(".aplenglowee-cart");
      const $drawerSelector = $(event.target).closest(
        ".aplenglowee-cart-drawer"
      );

      if ($cartBtnSelector.length === 0 && $drawerSelector.length === 0) {
        closeCartDrawer();
      }
    }
  });
}

$(document).ready(function () {
  // handleHeaderHeight();
  
  handleMenuScrollState();
  handleClickOutsideCartDrawer();
});
